import { apiConfig } from '../config/api';

function stripTrailingSlashes(s: string): string {
  return s.replace(/\/+$/, '');
}

/**
 * Resolves learner/admin media that lives under `/uploads/...` against the
 * configured API base (including runtime `apiConfig`). Any absolute `http(s)`
 * URL whose path starts with `/uploads/` is rebased so the same content works
 * on localhost, UAT, and production without hardcoding an environment.
 */
export function normalizeAppHostedUploadUrl(
  url: string | null | undefined,
  options?: { apiBaseOverride?: string }
): string {
  if (url == null) return '';
  const raw = String(url).trim();
  if (!raw) return '';

  if (/^data:/i.test(raw) || /^blob:/i.test(raw)) {
    return raw;
  }

  const base = stripTrailingSlashes((options?.apiBaseOverride ?? apiConfig.getBaseUrl() ?? '').trim());

  const withApiBase = (pathFromRoot: string) => {
    const path = pathFromRoot.startsWith('/') ? pathFromRoot : `/${pathFromRoot}`;
    if (!base) return path;
    return `${base}${path}`;
  };

  if (raw.startsWith('/uploads/')) {
    return withApiBase(raw);
  }

  if (/^https?:\/\//i.test(raw)) {
    try {
      const u = new URL(raw);
      if (u.pathname.toLowerCase().startsWith('/uploads/')) {
        return withApiBase(`${u.pathname}${u.search}${u.hash}`);
      }
    } catch {
      /* ignore */
    }
    return raw;
  }

  if (!raw.startsWith('/')) {
    return withApiBase(`/uploads/images/${raw}`);
  }

  return raw;
}
